export const DIFFERENCE_NUMBER_USER = 100000;
